<template>
  <div class="style-guide">
    <div>
      <h1>Orca Style Guide</h1>
      <div>
        <h1>Logo</h1>
        <div class="logos-container">
          <div class="logo-container"><img src="@/assets/logo-1.png" class="logo-1"></div>
          <div class="logo-container"><img src="@/assets/logo-2.png" class="logo-2"></div>
        </div>
      </div>
      <h1>Colors</h1>
      <div class="card-content">
        <div class="color-blocks-div">
          <div class="color-block"></div>
          <div class="color-block color-1"></div>
          <div class="color-block color-2"></div>
          <div class="color-block color-3"></div>
          <div class="color-block color-4"></div>
          <div class="color-block color-5"></div>
          <div class="color-block color-6"></div>
        </div>
        <div class="color-blocks-div">
          <div class="color-block color-7"></div>
          <div class="color-block color-8"></div>
          <div class="color-block color-9"></div>
          <div class="color-block color-alarm"></div>
          <div class="color-block color-danger"></div>
          <div class="color-block color-warning"></div>
          <div class="color-block color-success"></div>
        </div>
      </div>
      <div>
        <h1>Headings</h1>
        <h1>H1 Neurial Grotesk</h1>
        <h2>H2 Neurial Grotesk</h2>
        <h3>H3 Neurial Grotesk</h3>
        <h4>H4 Neurial Grotesk</h4>
        <h5>H5 Neurial Grotesk</h5>
        <h6>H6 Neurial Grotesk</h6>
      </div>
      <div>
        <h1>Fonts</h1>
        <div>
          <div>
            <div class="smaller">.smaller Neurial Grotesk</div>
            <div class="small">.small  Neurial Grotesk</div>
            <div>default Neurial Grotesk</div>
            <div class="big">.big  Neurial Grotesk</div>
            <div class="bigger">.bigger  Neurial Grotesk</div>
            <div class="dim">.dim  Neurial Grotesk</div>
            <div class="dark">.dark  Neurial Grotesk</div>
            <div class="bold">.bold  Neurial Grotesk</div>
            <div class="medium">.medium  Neurial Grotesk</div>
            <div class="light">.light  Neurial Grotesk</div>
            <div class="light bigger">.light.bigger  Neurial Grotesk</div>
            <div class="bigger">.bigger  Neurial Grotesk</div>
            <div class="bigger dim">.bigger.dim  Neurial Grotesk</div>
            <div class="bigger bold">.bigger.bold  Neurial Grotesk</div>
            <div class="bigger bold dim">.bigger.bold.dim Neurial Grotesk</div>
            <div class="biggest">.biggest  Neurial Grotesk</div>
            <div class="biggest dim">.biggest.dim Neurial Grotesk</div>
            <div class="biggest bold">.biggest.bold  Neurial Grotesk</div>
            <div class="biggest bold dim">.biggest.bold.dim Neurial Grotesk</div>
          </div>
          <h3>Paragraph</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.</p>
        </div>
      </div>
      <div>
        <h1>Buttons</h1>
        <div class="buttons-container">
          <button class="btn btn-smaller">.btn.btn-smaller</button>
          <button class="btn btn-small">.btn.btn-small</button>
          <button class="btn">.btn</button>
          <button class="btn btn-big">.btn.btn-big</button>
          <button class="btn btn-bigger">.btn.btn-bigger</button>
        </div>
        <div class="buttons-container">
          <button class="btn btn-1">.btn.btn-1</button>
          <button class="btn-1 btn btn-bigger">.btn.btn-1.btn-bigger</button>
        </div>
      </div>

      <div>
        <h1>Form Inputs</h1>
        <div>
          <div class="w-form">
            <form id="email-form" name="email-form" data-name="Email Form">
              <div class="field">
                <input type="text" name="fullname" placeholder="Jane Appleseed">
                <label for="fullname">Name</label>
              </div>
              <div class="field">
                <textarea name="textarea" placeholder="Example Text"></textarea>
                <label for="textarea">Message</label>
              </div>
              <div>
                <input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox" class="w-checkbox-input">
                <label for="checkbox" class="w-form-label">Checkbox</label>
              </div>
              <div>
                <input type="radio" id="radio" name="radio" value="Radio" data-name="Radio" class="w-radio-input">
                <label for="radio" class="w-form-label">Radio</label>
              </div>
                <select>
                  <option value="">Select one...</option>
                  <option value="First">First Choice</option>
                  <option value="Second">Second Choice</option>
                  <option value="Third">Third Choice</option>
                </select>
                <input type="submit" value="Cancel" class="btn btn-1">
              <input type="submit" value="Submit" class="btn"></form>
          </div>
        </div>
      </div>

      <div>
        <h1>Spinner</h1>
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
      <div>
        <h1>Card Content</h1>
        <div>
          <div class="card-content sample">
            <div class="text-block">.card-content</div>
          </div>
        </div>
      </div>
      <div>
        <h1>Card Content</h1>
        <div>
          <div class="card-content-2 sample">
            <div class="text-block">.card-content</div>
          </div>
        </div>
      </div>
      <div>
        <h1>Modal</h1>
        <div class="modal">
          <div class="modal-header">
            <h3 class="dark">Modal Title</h3>
          </div>
          <div class="modal-body">
            <h1>Modal Body</h1>
          </div>
          <div class="modal-footer">
            <button value="Cancel" class="btn btn-1">Cancel</button>
            <button value="Submit" class="btn">Submit</button>
          </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'StyleGuide'
}
</script>

<style lang="scss">
.style-guide {
  border-radius: 7px;
  font-family: Neurialgrotesk, sans-serif;
  text-align: left;
  max-width: 800px;
  margin: auto;
  padding: 10px 30px 30px;
}

.logo-1, .logo-2 {
  max-height: 100px;
  margin-right: 0px;
}

.color-blocks-div {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.div-block-3 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.logos-container {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.div-block-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 200px;
  height: 200px;
  max-height: 200px;
  max-width: 200px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 3px 3px 4px 0 #757575;
}

.div-block-6 {
  padding: 10px;
  background-color: #ededed;
}

.div-block-7 {
  display: block;
  overflow: visible;
  width: 600px;
  height: 650px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.color-block {
  width: 100px;
  height: 100px;
  margin: 5px;
  box-shadow: 1px 1px 3px 0 #e3e3e3;
}
.color-1 {
  background-color: $color-1;
}
.color-2 {
  background-color: $color-2;
}
.color-3 {
  background-color: $color-2-light;
}

.color-4 {
  background-color: $gray-1;
}

.color-5 {
  background-color: $gray-2;
}

.color-6 {
  background-color: $light-1;
}

.color-7 {
  background-color: $dark-1;
}

.color-8 {
  background-color: $dark-1;
}

.color-9 {
  background-color: $dark-1;
}

.color-alarm {
  background-color: $alarm;
}

.color-danger {
  background-color: $danger;
}

.color-warning {
  background-color: #ffc727;
}

.color-success {
  background-color: #91d438;
}

.buttons-container {
  flex-direction: row
}

.sample {
  width: 200px;
  height: 200px;
}

</style>
